/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description: 
 */
import React from "react";
import PropTypes from "prop-types";
import "./style.less";

class PipelineImageText extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {}

  render() {
    const { baseConfig = {}, imageTextConfig = {} } = this.props.config;
    return (
      <div
        className="pipeline-imageText"
        {...this.props['customAttributes']}
        style={{
          paddingTop: baseConfig.moduleMarginTop >= 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginTop: baseConfig.moduleMarginTop < 0 ? `${baseConfig.moduleMarginTop}px` : 0,
          marginLeft: `${baseConfig.moduleMarginHorizon}px`,
          marginRight: `${baseConfig.moduleMarginHorizon}px`
        }}
      >
        <img src={imageTextConfig.image} alt="" />
      </div>
    );
  }
}

PipelineImageText.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineImageText };
export default PipelineImageText;



// WEBPACK FOOTER //
// ./components/pipeline-imageText/index.js